import React from "react";
import styled from "styled-components";
import { transparentize } from "polished";

const RefPreviewLink = styled.span`
  display: inline-block !important;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  border-bottom: 3px solid
    ${({ theme }) =>
      transparentize(
        0.7,
        theme.darkMode ? theme.primaryText : theme.primary
      )} !important;
`;

const ScriptureRef: React.FC<{
  refId: string;
  showRefPreview: (refId: string) => void;
}> = ({ refId, showRefPreview, children }) => (
  <RefPreviewLink onClick={() => showRefPreview(refId)}>
    {children}
  </RefPreviewLink>
);

export default ScriptureRef;
